import styled from "styled-components";

export const SlideoutContainer = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	padding-top: 24px;
	padding-bottom: 0;
`;

export const SlideoutHeader = styled.div`
	display: flex;
	flex-direction: column;
	gap: 24px;
	flex-shrink: 0;
	margin-bottom: 24px;
	
 & > div:nth-child(2) > div {
	 border-radius: 8px;
	 border-color: ${(props) => props.theme.colors.davysGrey};
 }
`;

export const SlideoutSubHeader = styled.div`
	display: flex;
	justify-content: flex-start;
	align-items: center;
`;

export const SlideoutContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 24px;
	flex: 1;
	min-height: 0;
	
	& > div {
    padding: 0px 8px 0px 0px;
	}
`;

export const SlideoutActions = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	gap: 8px;
	padding: 16px 0;
	margin-top: auto;
	flex-shrink: 0;
`;

export const SlideoutDrivesContainer = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
	overflow-y: auto;
	overflow-x: hidden;
	min-height: 0;
	margin-bottom: 0;

	& > div > button, & > div > button:hover, & > div > button:active {
		flex:1;
    justify-content: center;
	}
`;

export const BackButtonWrapper = styled.div`
	display: flex;
	cursor: pointer;
`;

